import Header from '@/components/feature/Header';
import Hero from '@/components/feature/Hero';
import Footer from '@/components/feature/Footer';
import SectionUpdates from './components/SectionUpdates';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionAbout from './components/SectionAbout';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionMedia from './components/SectionMedia';
import SectionFeatures from './components/SectionFeatures';
import SectionFaq from './components/SectionFaq';
import SectionComments from './components/SectionComments';
import SectionTopics from './components/SectionTopics';
import SectionRanking from './components/SectionRanking';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门吃瓜', href: '#cards' },
  { label: '吃瓜热评', href: '#comments' },
  { label: '平台优势', href: '#features' },
  { label: '爆料投稿', href: '#contact' },
  { label: '常见问题', href: '#faq' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionApp />
        <SectionCarousel />
        <SectionContact />
        <SectionAbout />
        <SectionCards />
        <SectionIndex />
        <SectionMedia />
        <SectionFeatures />
        <SectionFaq />
        <SectionComments />
        <SectionTopics />
        <SectionRanking />
      </main>
      <Footer />
    </div>
  );
}